import { NoteBoxAnchor, NoteBoxVersion } from 'src/models/anchor-and-version/note-box.model';
import { createBaseAnchor, createBaseVersion } from './base.factory';

export function createNoteBoxAnchor(
    aParams: {
        // Base
        logText: string;
        // Specific
        aedAnchorKey: number;
    },
    vParams: {
        // Base
        comment: string;
        logText: string;
        name: string;
        // Specific
        x: number;
        y: number;
        z: number;
        height: number;
        width: number;
        text: string;
        dock: number;
    }
): NoteBoxAnchor {
    const version = createNoteBoxVersion({ ...vParams, anchorKey: 0, changeRequestKey: 1 });
    const anchor: NoteBoxAnchor = {
        ...createBaseAnchor(aParams),
        aedAnchorKey: aParams.aedAnchorKey,
        displayName: null,
        allVersions: [version],
        validVersion: version,
    };

    return anchor;
}

export function createNoteBoxVersion(params: {
    // Base
    anchorKey: number;
    changeRequestKey: number;
    comment: string;
    logText: string;
    name: string;
    // Specific
    x: number;
    y: number;
    z: number;
    height: number;
    width: number;
    text: string;
    dock: number;
}): NoteBoxVersion {
    const baseVersion = createBaseVersion(params);
    const version: NoteBoxVersion = {
        ...baseVersion,
        x: params.x,
        y: params.y,
        z: params.z,
        height: params.height,
        width: params.width,
        text: params.text,
        dock: params.dock,
    };

    return version;
}
